import { getItemById } from '../../components/BusinessAppointments/FilterBusinessAppointments/internal/helpers/getItemById';
import { TReadyBusinessGroupItem } from '../../components/BusinessAppointments/FilterBusinessAppointments/types';
import { IAppState } from '../../redux';
import { TSpeciality } from '../../redux/reducers';
import { EBusinessType } from '../../types/businessType';
import { businessAppointmentsDataSelector } from './businessAppointmentsDataSelector';
import { filterReadyBusinessTypesSelector } from './filterReadyBusinessTypesSelector';
import { selectSpecialties } from './selectSpecialties';

export function filterBusinessAppointmentsSelector(state: IAppState): TSpeciality[] {
  const businessAppointments = businessAppointmentsDataSelector(state);
  const readyBusinessType = filterReadyBusinessTypesSelector(state);
  const [specialty] = selectSpecialties(state);

  if (!specialty || !readyBusinessType || !businessAppointments) {
    return [];
  }

  const items = (() => {
    if (readyBusinessType === EBusinessType.ReadyBusiness || readyBusinessType === EBusinessType.Other) {
      return businessAppointments.readyBusiness.groups;
    }

    return [{ items: businessAppointments.rentalBusiness.items }] as TReadyBusinessGroupItem[];
  })();

  const item = getItemById(specialty.id, items);

  if (!item) {
    return [];
  }

  return [{ id: item.id, rusName: item.name, engName: item.keyName }];
}
